export default "__VITE_ASSET__DqgpMRW9__"